import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal__bike-wrapper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "modal__bike-content"
}
const _hoisted_4 = { class: "modal__bike-row" }
const _hoisted_5 = { class: "modal__bike-label" }
const _hoisted_6 = { class: "modal__bike-amount" }
const _hoisted_7 = {
  key: 0,
  class: "modal__bike-row"
}
const _hoisted_8 = { class: "modal__bike-label" }
const _hoisted_9 = {
  key: 1,
  class: "modal__bike-row"
}
const _hoisted_10 = { class: "modal__bike-label" }
const _hoisted_11 = { class: "modal__bike-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.descriptionTop)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal__description",
          innerHTML: _ctx.descriptionTop
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.staticParams.BIKE_STATIONS_VIEW_ENABLE && _ctx.staticParams.BIKE_STATIONS_VIEW_ENABLE == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_translated_text_component, { translation: "bike_spaces_available" }),
              _cache[0] || (_cache[0] = _createTextVNode(": "))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "mdi mdi-bicycle" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.totalBikeSpots), 1)
            ])
          ]),
          (_ctx.availableBikes >= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_translated_text_component, { translation: "bike_available_label" }),
                  _cache[2] || (_cache[2] = _createTextVNode(": "))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["modal__bike-amount", _ctx.availableBikes < 1 ? '--full' : '--free'])
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "mdi mdi-bicycle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.availableBikes), 1)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.safetyLockBikes >= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_translated_text_component, { translation: "bike_safety_lock" }),
                  _cache[4] || (_cache[4] = _createTextVNode(": "))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "mdi mdi-lock" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.safetyLockBikes), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}